import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

const surveyPreSave = (payload) => {
  if (payload?.assignee) {
    payload.assignee = { _id: payload.assignee._id, account: { _id: payload?.assignee?.account?._id || payload.assignee?.accountId } };
  }
  return payload;
};

export const organizationFileApprovalSurvey = createCrudVuexModule({
  namespaced: true,
  path: "/file-approval-survey",
  options: { localizedFields: ["name", "unit", "title"] },
  persistent: ["survey"],

  state: {
    survey: undefined,
    inProgressSurveyPagination: undefined,
    complatedSurveyPagination: undefined,
    memberPagination: undefined,
    resultsPagination: undefined,
    editedMember: undefined,
    selectedTab: 0,
  },
  getters: {
    selectedTab: (state) => state.selectedTab,
    inProgressSurveyPagination: (state) => state.inProgressSurveyPagination,
    complatedSurveyPagination: (state) => state.complatedSurveyPagination,
    memberPagination: (state) => state.memberPagination,
    resultsPagination: (state) => state.resultsPagination,
    editedMember: (state) => state.editedMember,
    survey: (state) => state.survey,
  },
  mutations: {
    selectedTab: (state, value) => (state.selectedTab = value),
    inProgressSurveyPagination: (state, value) => (state.inProgressSurveyPagination = value),
    complatedSurveyPagination: (state, value) => (state.complatedSurveyPagination = value),
    memberPagination: (state, value) => (state.memberPagination = value),
    resultsPagination: (state, value) => (state.resultsPagination = value),
    editedMember: (state, value) => (state.editedMember = value),
    survey: (state, value) => (state.survey = value),
  },
  actions: {
    async reSend({ getters, commit, dispatch }, id) {
      commit("isUpdating", true);
      try {
        const response = await rest.get(`/file-approval-survey/resend/${id}`);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async completeSurvey({ getters, commit, dispatch }, id) {
      commit("isUpdating", true);
      try {
        const response = await rest.get(`/file-approval-survey/complete-survey/${id}`);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async createSurvey({ getters, commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post(`/file-approval-survey/`, payload);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async fetchInProgressSurveys({ getters, commit, dispatch }, { pagination, fileId }) {
      commit("isUpdating", true);
      try {
        const payload = { ...pagination, query: { ...pagination.query, status: { value: "IN_PROGRESS", isObject: true } } };
        const response = await rest.post(`/file-approval-survey/paginateWith`, { pagination: payload, id: fileId });
        commit("inProgressSurveyPagination", response.data);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async fetchSurveyDetail({ getters, commit, dispatch }, id) {
      commit("isUpdating", true);
      try {
        const response = await rest.get(`/file-approval-survey/${id}`);
        commit("survey", response.data);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async fetchComplatedSurveys({ getters, commit, dispatch }, { pagination, fileId }) {
      commit("isUpdating", true);
      try {
        const payload = { ...pagination, query: { ...pagination.query, status: { value: "DONE", isObject: true } } };
        const response = await rest.post(`/file-approval-survey/paginateWith`, { pagination: payload, id: fileId });
        commit("complatedSurveyPagination", response.data);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async fetchMembers({ getters, commit, dispatch }, pagination) {
      commit("isUpdating", true);
      try {
        const response = await rest.post(`/file-approval-survey/member/paginate`, { pagination });
        commit("memberPagination", response.data);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async fetchResults({ getters, commit, dispatch }, id) {
      commit("isUpdating", true);
      try {
        const response = await rest.get(`/file-approval-survey/${id}/results`);
        commit("resultsPagination", response.data);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async saveMember({ getters, commit, dispatch }, { member, file }) {
      commit("isUpdating", true);
      try {
        let payload = await dispatch("preparePayload", {
          editedEntity: {},
          form: member,
        });
        payload = surveyPreSave(payload);

        let response;
        if (member && member._id) {
          response = await rest.put(`/file-approval-survey/member`, { item: { _id: payload._id, participant: payload, file: file } });
        } else {
          response = await rest.post(`/file-approval-survey/member`, { item: { surveyParticipant: payload, file: file } });
        }

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async deleteMember({ getters, commit, dispatch }, id) {
      commit("isUpdating", true);
      try {
        await rest.delete(`/file-approval-survey/member/${id}`);
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
